module.exports = "/packs/shares-4931024-dcdd644b3fe5cd9d454af54d3930bd7e.png";